/**
 * Browser polyfills + touch Safari fixes.
 * Load synchronously in <head> before other theme scripts.
 */
(function (window, document) {
  'use strict';

  /* -------------------------------------------------------------------------- */
  /* matchMedia.addEventListener (Safari < 14)                                  */
  /* -------------------------------------------------------------------------- */
  if (typeof window.matchMedia === 'function') {
    try {
      var mqlProto = window.matchMedia('(min-width: 0px)').constructor.prototype;
      if (mqlProto && !mqlProto.addEventListener && mqlProto.addListener) {
        mqlProto.addEventListener = function (type, listener) {
          if (type === 'change') this.addListener(listener);
        };
        mqlProto.removeEventListener = function (type, listener) {
          if (type === 'change') this.removeListener(listener);
        };
      }
    } catch (e) {
      /* ignore */
    }
  }

  /* -------------------------------------------------------------------------- */
  /* requestIdleCallback / cancelIdleCallback                                   */
  /* -------------------------------------------------------------------------- */
  if (!window.requestIdleCallback) {
    window.requestIdleCallback = function (callback, options) {
      var timeout = options && options.timeout ? options.timeout : 1;
      var start = Date.now();
      return window.setTimeout(function () {
        callback({
          didTimeout: true,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - start));
          }
        });
      }, Math.min(timeout, 50));
    };
  }

  if (!window.cancelIdleCallback) {
    window.cancelIdleCallback = function (id) {
      window.clearTimeout(id);
    };
  }

  /* -------------------------------------------------------------------------- */
  /* Touch / iOS detection + single-tap fixes                                   */
  /* -------------------------------------------------------------------------- */
  var doc = document.documentElement;
  var isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var isTouch =
    isIOS ||
    (navigator.maxTouchPoints > 0 && window.matchMedia('(pointer: coarse)').matches);

  if (isTouch) doc.classList.add('is-touch');
  if (isIOS) doc.classList.add('is-ios');

  /* Activates fast single-tap path in WebKit (avoids double-tap zoom delay). */
  document.addEventListener('touchstart', function () {}, { passive: true, capture: true });

  function dismissGhostDialogs() {
    document
      .querySelectorAll('x-drawer:not([open]), x-modal:not([open]), x-popover:not([open])')
      .forEach(function (el) {
        if (el.hasAttribute('open')) return;
        if (window.getComputedStyle(el).display === 'none') return;
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
      });
  }

  function onTouchStart() {
    if (isIOS) dismissGhostDialogs();
  }

  document.addEventListener('touchstart', onTouchStart, { passive: true, capture: true });
  document.addEventListener('variant:change', dismissGhostDialogs);
  document.addEventListener('product:rerender', dismissGhostDialogs);
  document.addEventListener('dialog:after-hide', dismissGhostDialogs);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dismissGhostDialogs);
  } else {
    dismissGhostDialogs();
  }

  window.GuttelusPolyfills = {
    isIOS: isIOS,
    isTouch: isTouch,
    dismissGhostDialogs: dismissGhostDialogs
  };
})(window, document);
